import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { Equipment } from '../../Models/Equipment';
import { formatNumbers } from '../../Utils';
import PaginatedTable from '../Common/PaginatedTable';
import { HiDownload } from 'react-icons/hi';
import { EquipmentVideo } from '../../Models/EquipmentVideo';

export default function ProductVideos({ data }: { data: EquipmentVideo[] }) {
  const columnHelper = createColumnHelper<EquipmentVideo>();
  const columns = [
    columnHelper.accessor((row) => row.safeVideoURL, {
      id: 'safeVideoURL',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <iframe
            width='560'
            height='315'
            src={`${info.row.original.safeVideoURL}`}
          ></iframe>
        </div>
      ),
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.caption, {
      id: 'caption',
      header: '',
      sortingFn: 'alphanumeric',
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  return (
    <div className='w-full mx-auto overflow-x-auto'>
      <PaginatedTable
        table={table}
        dataCount={data.length}
        columnResizeMode='onChange'
        showFilters={true}
      />
    </div>
  );
}
